import { querySelectorURL } from "../../cpcoc/querySelectorURL";
import { slideOptions } from "./slideOptions";
export function setSlideDimensions() {
    if (querySelectorURL("screentype") === "viewport") {
        slideOptions.width =
            querySelectorURL("width") || window.innerWidth;
        slideOptions.height =
            querySelectorURL("height") || window.innerHeight;
    }
    else if (querySelectorURL("screentype") === "default") {
        // empty, and do nothing in this situation.
    }
    else {
        slideOptions.width =
            querySelectorURL("width") || screen.width;
        slideOptions.height =
            querySelectorURL("height") || screen.height;
    }
    if (querySelectorURL("ratio")) {
        const ratio = String(querySelectorURL("ratio")).split(":");
        slideOptions.height =
            (Number(slideOptions.width) * Number(ratio[1])) / Number(ratio[0]);
    }
}
